/** Channel media in our storage, reload from Instagram and post versions (ALP-77 media fix). */
export const media = {
  image: {
    unavailable: "Image unavailable",
    refreshing: "Refreshing image…",
    copying: "Copying media…",
    copyingHint: "Malfak is saving a copy of this post's media so it never breaks.",
    video: "Video",
    notMirrored: "Shown from Instagram (copy pending)",
  },
  reload: {
    action: "Reload from Instagram",
    hint: "Fetch caption, media, counts, insights and new comments from Instagram. Changes are kept as versions.",
    selected_one: "Reload {{count}} post",
    selected_other: "Reload {{count}} posts",
    account: "Reload @{{user}} posts",
    all: "Reload all imported posts",
    started: "Reload started",
    failed: "Couldn't start the reload",
    select: "Select",
    selectAll: "Select all posts",
    selectPost: "Select post",
    clear: "Clear selection",
  },
  refresh: {
    pictures: "Reload pictures",
    picturesHint: "Copy this account's post media and profile pictures into Malfak again.",
    started: "Refreshing media",
    failed: "Couldn't refresh media",
  },
  edited: {
    badge: "Edited on Instagram",
    hint: "Instagram content changed {{when}}. Previous versions are kept below.",
  },
  versions: {
    title: "Versions",
    hint: "Every change to the caption or media, from Instagram or Malfak.",
    empty: "No versions yet. Reloading from Instagram records one when something changed.",
    current: "Current",
    version: "Version {{n}}",
    source: {
      import: "Imported",
      instagram_edit: "Edited on Instagram",
      malfak_edit: "Edited in Malfak",
    },
    compareWith: "Changes from version {{n}}",
    firstVersion: "First version: nothing to compare with.",
    noChanges: "Same caption as the previous version.",
    added: "Added",
    removed: "Removed",
    before: "Before",
    after: "After",
    media: "Media",
    noMedia: "No media",
    mediaCount_one: "{{count}} item",
    mediaCount_other: "{{count}} items",
    restore: "Restore",
    restoreTitle: "Restore version {{n}}?",
    restoreBody: "Malfak will show this version's caption and media. Instagram is not changed: its API does not allow editing a published caption.",
    restored: "Version {{n}} restored in Malfak",
    restoreFailed: "Couldn't restore this version",
    localOnly: "Local only",
  },
  repair: {
    title: "Media repair",
    hint: "Copies every Instagram image Malfak still links to (posts, profile pictures, DM attachments) into storage. Safe to run again.",
    org: "Reload all pictures",
    orgHint: "Copy any image that is not saved in Malfak yet.",
    started: "Media repair started",
    failed: "Couldn't start the media repair",
    runAll: "Repair all organizations",
    run: "Repair",
    posts: "Posts",
    avatars: "Pictures",
    attachments: "Attachments",
    failedItems: "Failed",
    lastRun: "Last run {{when}}",
    never: "Never run",
    allClear: "Every image is saved in storage.",
    config: "Videos copied: {{videos}} · image limit {{image}} MB · video limit {{video}} MB",
    yes: "yes",
    no: "no",
    lastJob: "Last job",
  },
};
